import PropTypes from "prop-types";

import { H1, H2 } from "../../../../AbstractElements";
import FileHandler from "../../../../CommonElements/FileHandler";
import StarRating from "../../../../CommonElements/StarRating";

const Rating = ({
  questionId,
  questionNumber,
  title,
  options,
  handleChange,
  isChecked,
  mediaUrl,
}) => {
  // Find the selected option index (for StarRating initialValue)
  const selectedIndex = options?.findIndex(option =>
    isChecked(option.option_id, questionId)
  );
  // StarRating uses 1-based index for value
  const initialValue = selectedIndex >= 0 ? selectedIndex + 1 : 0;

  // When user clicks a star/point, map index to option_id
  const onStarClick = rate => {
    // rate is 1-based index
    const idx = rate - 1;
    if (options && options[idx]) {
      handleChange(options[idx].option_id, questionId);
    }
  };

  return (
    <div className="single-choise">
      <H1 className="single-choise__question">{questionNumber}</H1>
      <H2 className="single-choise__title">{title}</H2>
      {mediaUrl && <FileHandler showPreview={true} mediaUrl={mediaUrl} />}
      <div>
        <StarRating
          size={32}
          count={options?.length || 6}
          onClick={onStarClick}
          initialValue={initialValue}
          disabled={false}
        />
      </div>
    </div>
  );
};

Rating.propTypes = {
  questionId: PropTypes.string.isRequired,
  questionNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  title: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      option_id: PropTypes.string.isRequired,
    })
  ).isRequired,
  handleChange: PropTypes.func.isRequired,
  isChecked: PropTypes.func.isRequired,
  mediaUrl: PropTypes.string,
};

export default Rating;
